/**
 * Minimum number of players required to start a VAIR gameday.
 * VAIR events support 4–9 players.
 */
export const VAIR_MINIMUM_PLAYERS = 4;

/**
 * Maximum number of players for a VAIR event.
 */
export const VAIR_MAX_PLAYERS = 9;

/**
 * Default minutes per match when generating VAIR schedules.
 */
export const DEFAULT_TIME_PER_MATCH = 20;

export const VAIR_PRO_URL = 'https://vairpro.vairified.com/';

/**
 * Whether VAIR_CONNECT_PAGE may resolve a `?vairId=` into a name for its greeting.
 *
 * The page is unauthenticated by design — a player arrives from VAIR before they have a Bounce
 * account — so anyone who can guess a member id can turn it into a first name and a rating.
 * That is the deliberate price of the personalised landing; the lookup never returns an email
 * or a surname, and this flag turns the whole thing off if the trade stops being worth it.
 */
export const IS_VAIR_CONNECT_PREVIEW_ENABLED = true;

/**
 * Shown when a VAIR member is already bound to a *different* Bounce account. Used by the
 * connect page and by VairConnectionStatusModal, which is why the copy lives here rather than
 * in either of them.
 *
 * Deliberately not a "try again" message: retrying can never succeed, because only the holder
 * of the other Bounce account can unpick the connection.
 */
export const VAIR_ALREADY_CONNECTED_MESSAGE =
  'This VAIR account is already connected to another Bounce account. Log in to that account to manage the connection, or contact support if you think this is a mistake.';

/**
 * Shown when VAIR sign-in matches a Bounce account on email, but that account is already
 * connected to a different VAIR member. Used by the connect page and the VAIR sign-in page.
 */
export const VAIR_OTHER_MEMBER_CONNECTED_MESSAGE =
  'The Bounce account with this email is already connected to a different VAIR account, so we left it as it is. Contact support if you need to switch it.';
